export default __webpack_public_path__ + "images/XO.27b6cba.png";